export const secondsToMS = (second: number) => {
  if (second) {
    return new Date(second * 1000).toISOString().slice(14, 19);
  }
};